export default __webpack_public_path__ + "static/media/crystalia.0685b068.webp";